import { ConversionMultiConversion } from "@/types/defs/conversionMultiConversionNoDates";
import { ConversionConstructedNoDates } from "@/types/types";

export const isConversionMultiConversion = (
  conversionMultiConversionMaybe: ConversionConstructedNoDates
): conversionMultiConversionMaybe is ConversionMultiConversion => {
  return (
    "conversionMultiId" in conversionMultiConversionMaybe &&
    conversionMultiConversionMaybe.conversionMultiId !== null
  );
};
